import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "./firebase";

const tapesRef = collection(db, "tapes");

export function subscribeToTapes(ownerUserId, callback) {
  const q = query(tapesRef, where("ownerUserId", "==", ownerUserId), orderBy("createdAt", "desc"));
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
}

export function addTape(ownerUserId, data) {
  return addDoc(tapesRef, {
    ...data,
    ownerUserId,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export function updateTape(tapeId, data) {
  return updateDoc(doc(db, "tapes", tapeId), {
    ...data,
    updatedAt: serverTimestamp(),
  });
}

export function deleteTape(tapeId) {
  return deleteDoc(doc(db, "tapes", tapeId));
}
